import { Box } from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import { FormattedMessage } from 'react-intl'

export const ActionsLabelHidden = (): React.ReactElement => <Box
    component="span"
    sx={visuallyHidden}
>
    <FormattedMessage id="task_table_actions" defaultMessage="Actions" />
</Box>
